import {Answer} from '@/state/models/Answer';

export class AssessmentInProgress {
    public assessmentId: number | null = null;
    public studentId: number | null = null;
    public answerMap: Map<number, Answer> = new Map<number, Answer>();

    constructor(assessmentId: number, studentId: number) {
        this.assessmentId = assessmentId;
        this.studentId = studentId;
    }
}
